/**
* DEPRECATED RX CONNECTOR, USE THE UPDATED ONE IN front-end-core
*/
import React from 'react'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import { isFunction } from 'libraries/lodash'
import connect from 'front-end-core/decorators/connect'

export default (propSource) => (View, responseConsumerProps = {}) => {
  const $propSourceFn = isFunction(propSource) ? propSource : () => propSource
  return connect((props) => ({ response: $propSourceFn(props) }))(props => (
    <ResponseConsumer
      {...responseConsumerProps}
      response={props.response}
      content={() => <View {...props} {...props.response} />}
    />
  ))
}
